var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { UIComponent, childrenExist, commonPropTypes, } from '../../lib';
import createAnimationStyles from '../../lib/createAnimationStyles';
/**
 * An animation allows the user to animate their own components.
 */
var Animation = /** @class */ (function (_super) {
    __extends(Animation, _super);
    function Animation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Animation.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, rest = _a.rest, styles = _a.styles, variables = _a.variables, theme = _a.theme;
        var _b = this.props, children = _b.children, name = _b.name;
        var animation = {
            name: name,
            duration: this.props.duration,
            delay: this.props.delay,
            iterationCount: this.props.iterationCount,
            direction: this.props.direction,
            fillMode: this.props.fillMode,
            playState: this.props.playState,
            timingFunction: this.props.timingFunction,
        };
        var animationStyle = createAnimationStyles(animation, theme);
        var child = childrenExist(children) && React.Children.only(children);
        var result = child
            ? React.cloneElement(child, {
                style: __assign({}, animationStyle, (child.props && child.props.style)),
            })
            : '';
        return (React.createElement(ElementType, __assign({ className: classes.root }, rest), result));
    };
    Animation.className = 'ui-animation';
    Animation.displayName = 'Animation';
    Animation.propTypes = __assign({}, commonPropTypes.createCommon({
        animated: false,
        content: false,
        children: 'element',
    }), { name: PropTypes.string, delay: PropTypes.string, direction: PropTypes.string, duration: PropTypes.string, fillMode: PropTypes.string, iterationCount: PropTypes.string, playState: PropTypes.string, timingFunction: PropTypes.string });
    return Animation;
}(UIComponent));
export default Animation;
